import * as Popover from '@radix-ui/react-popover'
import { type NodeViewProps, NodeViewWrapper } from '@tiptap/react'
import { ChevronDown } from 'lucide-react'
import { Input } from '#app/components/ui/input.js'
import { BASE_VARIABLES } from '#app/utils/constants.js'
import { setPageVariables } from '#app/utils/page.client'

const Component = (props: NodeViewProps) => {
	const { vars, data } = props.extension.options
	let availableVars = [{ id: 'default', name: 'Select a variable' }]

	if (vars.sub) {
		availableVars.push(...BASE_VARIABLES.SUB)
	}
	if (vars.list) {
		availableVars.push(...BASE_VARIABLES.LIST)
	}
	if (vars.user) {
		availableVars.push(...BASE_VARIABLES.USER)
	}

	const editable = props.editor.isEditable

	if (editable) {
		const handleIdChange = (value: string) => {
			props.updateAttributes({
				id: value,
			})
		}

		const handleFallbackChange = (value: string) => {
			const sanitizedValue = value.replace(/;/g, '')
			props.updateAttributes({
				fallback: sanitizedValue,
			})
		}

		return (
			<NodeViewWrapper className="react-component" as="span">
				<Popover.Root>
					<Popover.Trigger className="">
						<span
							className="underline decoration-dotted underline-offset-4"
							contentEditable={false}
						>
							{String(
								availableVars.find(v => v.id === props.node.attrs.id)?.name,
							)}
						</span>
					</Popover.Trigger>
					<Popover.Portal>
						<Popover.Content
							className="custom-popover z-50 flex items-center gap-1 rounded-xl border border-border bg-white p-2 shadow-sm"
							sideOffset={8}
						>
							<div className="flex flex-col gap-2">
								<div className="relative">
									<select
										name="variable"
										className="h-[32px] w-full appearance-none rounded-lg border border-border px-2 outline-none hover:outline-none active:outline-none"
										value={props.node.attrs.id}
										onChange={e => handleIdChange(e.currentTarget.value)}
									>
										{availableVars.map(v => {
											return (
												<option key={v.id} value={v.id}>
													{v.name}
												</option>
											)
										})}
									</select>
									<ChevronDown
										className="pointer-events-none absolute inset-y-1 right-1.5"
										width={16}
									/>
								</div>
								<Input
									type="text"
									variant="s"
									placeholder="Fallback"
									value={props.node.attrs.fallback}
									onChange={e => handleFallbackChange(e.currentTarget.value)}
									onKeyDown={e => {
										if (e.key === ';') {
											e.preventDefault()
										}
									}}
								/>
							</div>
						</Popover.Content>
					</Popover.Portal>
				</Popover.Root>
			</NodeViewWrapper>
		)
	} else {
		const id = props.node.attrs.id
		const fallback = props.node.attrs.fallback

		const { content } = setPageVariables({
			content: `{{${id};${fallback}}}`,
			vars: { ...data },
		})

		return (
			(id || fallback) && (
				<NodeViewWrapper className="react-component" as="span">
					{content}
				</NodeViewWrapper>
			)
		)
	}
}

export default Component
